/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { CartIconComponent } from '@msdyn365-commerce/components';
import {
    getTelemetryObject,
    INodeProps,
    ITelemetryContent
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import React from 'react';

import { IDefaCartIconSimpleData } from './defa-cart-icon-simple.data';
import { IDefaCartIconSimpleProps } from './defa-cart-icon-simple.props.autogenerated';

export interface IMiniCartState {
}

export interface ICartIconViewProps extends IDefaCartIconSimpleProps<IDefaCartIconSimpleData> {
    className: string;
    cartIcon: React.ReactNode;
    miniCartWrapper: INodeProps;
}

/**
 *
 * Cart component.
 * @extends {React.PureComponent<ICartProps<ICartData>>}
 */
class CartIcon extends React.Component<IDefaCartIconSimpleProps<IDefaCartIconSimpleData>, IMiniCartState> {
    private readonly telemetryContent: ITelemetryContent;

    constructor(props: IDefaCartIconSimpleProps<IDefaCartIconSimpleData>) {
        super(props);
        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );
    }

    public render(): JSX.Element | null {
        const {
            id,
            typeName,
            context,
            resources
        } = this.props;

        const cart = (this.props.data.cart && this.props.data.cart.result) || undefined;

        const viewProps = {
            ...this.props,
            cartIcon: (
                <CartIconComponent
                    cartLabel={resources.cartLabel}
                    cartQtyLabel={resources.cartQtyLabel}
                    context={context}
                    id={id}
                    typeName={typeName}
                    data={{ cart }}
                    telemetryContent={this.telemetryContent}
                />
            ),
            miniCartWrapper: {
                className: classnames('ms-cart-icon'),
                id: this.props.id
            }
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default CartIcon;
